export interface CustomerApiModel {
  customerId: number;
  name: string;
  nameShortened: string;
}

export interface CustomerViewModel {
  customerId: number;
  name: string;
  nameShortened: string;
}

export const mapCustomersApiToViewModel = (customers: CustomerApiModel[]): CustomerViewModel[] => {
  return customers.map((customer) => ({
    ...customer
  }));
};